import { useCallback, useState } from 'react'

import { priceRe } from 'app/common/constants/regex'


export default function useAmountState() {
  const [amount, setAmount] = useState<string>('')

  const changeAmount = useCallback((value: string) => {
    if (priceRe.test(value)) {
      setAmount(value)
    }
  }, [])

  return { amount, changeAmount }
}
